import {
  CLEAR_ENTITY_DISPLAY,
  CLOSE_ATTACHMENT_MODAL,
  OPEN_ATTACHMENT_MODAL,
  POPUP_WINDOW_UPDATED,
  SET_ATTACHMENT_PREVIEW,
  SET_OPEN_DETAIL_FORM_TAB_ENTITY_DISPLAY,
  SET_OPEN_ERRORS_TAB_ENTITY_DISPLAY,
  SET_OPEN_STEP_FORM_TAB_ENTITY_DISPLAY,
} from '../actions/EntityDisplayActions';

const initialState = {
  attachmentModalOpen: false,
  openErrorsTab: false,
  openStepFormTab: false,
  openDetailFormTab: false,
};

function entityDisplayReducer(state = initialState, action) {
  switch (action.type) {
    case OPEN_ATTACHMENT_MODAL:
      return {
        ...state,
        attachmentModalOpen: true,
      };

    case CLOSE_ATTACHMENT_MODAL:
      return {
        ...state,
        attachmentModalOpen: false,
      };

    case SET_ATTACHMENT_PREVIEW: {
      const { filename, params, isOpen } = action.payload;
      return {
        ...state,
        attachment: isOpen ? { filename, params } : null,
      };
    }

    case SET_OPEN_ERRORS_TAB_ENTITY_DISPLAY:
      return {
        ...state,
        openErrorsTab: action.payload.openErrorsTab,
      };

    case SET_OPEN_STEP_FORM_TAB_ENTITY_DISPLAY:
      return {
        ...state,
        openStepFormTab: action.payload.openStepFormTab,
      };

    case SET_OPEN_DETAIL_FORM_TAB_ENTITY_DISPLAY:
      return {
        ...state,
        openDetailFormTab: action.payload.openDetailFormTab,
      };

    case POPUP_WINDOW_UPDATED:
      return {
        ...state,
        popupWindow: action.payload,
      };

    case CLEAR_ENTITY_DISPLAY:
      return initialState;

    default:
      return state;
  }
}

export default entityDisplayReducer;
